import _ from 'lodash';
import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import DealContext from '../DealContext';
import Flag from '../../Flag';

const CurrencyExchangeCard = () => {
  const { deal } = useContext(DealContext);

  return (
    <Card className="exchange-card">
      <Card.Body>
        <Card.Title>Exchange Rate</Card.Title>
        <div className="ex-set-line">
          <div className="ex-set-flags">
            <Flag size="sm">us</Flag>
            <i className="fas fa-long-arrow-alt-right mr-1 ml-1" />
            <Flag className="mr-1" size="sm">
              ca
            </Flag>
          </div>
          <div className="ex-set-values">
            <span>{_.get(deal, 'data.exchangeUS2CA', '1.00')}</span>
            {/* <input
        className="form-control"
        value={_.get(deal, 'data.exchangeUS2CA', '1.00')}
        disabled
        onChange={e => setName(e.target.value)}
        ref={editNameRef}
        maxLength="50"
      /> */}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CurrencyExchangeCard;
